import React from 'react';
import classNames from 'classnames';

import SitebarDropdown from './sitebarDropdown';
import Badge from 'src/components/badges/badge';
import {trackFootfallEvent} from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';

import api from 'src/utils/api';

import config from 'config/config';
import linkUtils from 'src/utils/linkUtils';
const PROGRAM_URL = config.cdn.programsIndex;

import i18n from 'i18next';

const getFixedHeight = (communityCount, programsCount) => {
  if (programsCount + communityCount >= 8) return 530;
  else if (programsCount === 0) return 110 + communityCount * 40;
  else return 200 + ((communityCount + programsCount) * 40);
};

class HubMenu extends React.Component {

  componentDidMount() {
    this.fetchPrograms();
  }

  fetchPrograms = async function() {
    const { data } = await api.get(`private/programs/subscribed?user-id=${this.props.userId}`);
    this.setState({ programs: data });
  }

  constructor(props) {
    super(props);
    this.state = { showAllCommunities: false, showAllPrograms: false, programs: [] };
  }

  render() {
    const { handleClick, open, followedCommunities } = this.props;
    const { showAllCommunities, showAllPrograms, programs } = this.state;
    const hubHeaderClasses = classNames({
      'hub-menu': true,
      'hub-menu--open': open,
    });
    const iconClasses = classNames({
      'icon-communities-solid': open,
      'icon-communities': !open,
    });
    const sortedCommunities = followedCommunities.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
    const COMMUNITIES_TO_SHOW = programs.length === 0 ? 10 : 5;
    const filteredCommunities = showAllCommunities ? sortedCommunities : sortedCommunities.slice(0, COMMUNITIES_TO_SHOW);
    const filteredPrograms = showAllPrograms ? programs : programs.slice(0, 3);

    return <div className={hubHeaderClasses}>
      <a href="#" className="hub-menu__heading hidden-xs" onClick={handleClick}>
        <span className={iconClasses} />
        <span className="hidden-sm">
          {' '}{i18n.t('My hub')}
        </span>
      </a>
      <SitebarDropdown open={open} fixedHeight={getFixedHeight(filteredCommunities.length, filteredPrograms.length)} addScrollWhenExceedsViewport={true}>
        <div className="divider">
          {i18n.t('Communities')}
        </div>
        <ul>
          {filteredCommunities.map(community => <li key={`hub-${community.slug}`}>
            <a href={`/${community.slug}`}>
              <img className="avatar" src={linkUtils.generateGroupImageUrl(community.logoImageHash, true)}/>
              {community.name}
            </a>
          </li>)}
          {((!showAllCommunities && followedCommunities.length <= 3) || showAllCommunities) && <li>
            <a href={'/find'} className="hub-menu__browse-communities__link">
              <img className="avatar" src={`${config.cdn.bg}BrowseCommunities.svg`}/>
              {i18n.t('Browse communities')}
            </a>
          </li>}
          {followedCommunities.length > 3 && <li>
            <a
              href="#"
              onClick={event => {
                event.stopPropagation();
                this.setState({ showAllCommunities: !showAllCommunities });
              }}
              className="sitebar-dropdown__link"
            >
              {showAllCommunities ? `- ${i18n.t('view less')}` : `+ ${i18n.t('view all your communities')}`}
            </a>
          </li>}
        </ul>
        {programs.length > 0 && <div className="divider">
          {i18n.t('Programs')}{' '}
          <Badge content={i18n.t('NEW')} type="new" />
        </div>}
        <ul>
          {programs.map(program => <li key={program.name}>
            <a href={`/programs/${program.code}`} onClick={e => {
              const element = program.name;
              trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'programs', element}, clickType: 'hub-menu' });
            }}>
              <img className="avatar" src={`${PROGRAM_URL}${program.code}.png`}/>
              {program.name}
            </a>
          </li>)}
          {programs.length > 3 && <li>
            <a
              onClick={event => {
                event.stopPropagation();
                this.setState({ showAllPrograms: !showAllPrograms });
              }}
              className="sitebar-dropdown__link"
            >
              {showAllPrograms ? `- ${i18n.t('view less')}` : `+ ${i18n.t('view all your programs')}`}
            </a>
          </li>}
        </ul>
      </SitebarDropdown>
    </div>;
  }
}

export default HubMenu;



// WEBPACK FOOTER //
// ./src/components/siteBar/hubMenu.js